<!--
  * @Author: changyunxia
  * @Date:2020年10月14日 13:33:54
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月14日 13:33:54
  * @Description: 会议室预约人选择组件
  * @FilePath:@/components/MeetingUser.vue
-->

<template>
  <div class="common-ibar">
    <van-search
      v-model="searchWord"
      class="search"
      show-action
      placeholder="请输入搜索关键词"
      @search="getFriend"
      @cancel="onCancel"
    />
    <!-- -->
    <div class="pdb" />
    <div>
      <div v-if="filteredSearchWord.length !==0" class="content">
        <van-cell v-for="(item,index) in filteredSearchWord" :key="index" :title="item.text" @click="clickItem(item)" />
      </div>

      <van-index-bar v-else :index-list="indexList" :sticky="false">
        <van-index-anchor v-for="friendGroup in handelList" :key="friendGroup.index" :index="friendGroup.index">
          <span :key="friendGroup.index" class="indexWord">{{ friendGroup.index }}</span>
          <van-cell v-for="item in friendGroup.item" :key="item.id" :title="item.text" @click="clickItem(item)" />
        </van-index-anchor>
      </van-index-bar>

    </div>

  </div>
</template>

<script>
import pinyin from 'js-pinyin'
import _ from 'lodash'
export default {
  name: 'CommonIbar',
  props: {
    list: {
      type: Array,
      required: true,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      searchWord: '',
      indexList: [],
      handelList: []

    }
  },
  computed: {
    // 计算数学，匹配搜索
    filteredSearchWord: function() {
      var arr = []
      if (this.searchWord !== '') {
        arr = this.list.filter(value => value.text.indexOf(this.searchWord) !== -1)
      }

      return arr
    }
  },
  watch: {
    list: {
      handler(newVal) {
        this.handelList = this.transData(newVal)
        this.indexList = this.handelList.map(item => item.index)
      },
      deep: true
      // immediate: true
    }
  },
  mounted() {
    this.handelList = this.transData(this.list)
    this.indexList = this.handelList.map(item => item.index)
  },
  methods: {
    transData(resource) {
      // 给每个元素添加first标识，用于分组
      const copySc = _.cloneDeep(resource)
      copySc.map(
        item => (item.first = pinyin.getCamelChars(item.text).substring(0, 1))
      )

      // 根据首字母分组和排序
      const groupObj = _.groupBy(copySc, 'first')
      const groupArr = Object.keys(groupObj).map(key => ({
        index: key,
        item: groupObj[key]
      }))
      const orderArr = _.orderBy(groupArr, 'index')

      return orderArr
    },
    getFriend() {
      this.$emit('search', this.searchWord)
    },
    onCancel() {
      this.$emit('update:showPicker', false)
    },
    clickItem(item) {
      this.$emit('update:isOpen', false)
      this.$emit('getUserName', item)
    }
  }
}
</script>
<style  lang='scss'  scoped>
.pdb{
     height: 55px;
}
.content{
  // padding-top: 60px;
  height:  calc(100vh - 55px);
  overflow: auto;
}
.search {
  position: fixed;
  z-index: 2;
  width: 100vw;
  box-shadow: 1px 1px 1px #eeeeee;
}
/deep/.van-index-anchor{
  padding: 0  !important;
}
.indexWord{
  display: block;
  background:#f7f8fa;
  padding-left: 16px;
}
</style>
